import React, { useState, useEffect } from "react"
import PropTypes from 'prop-types';
import ReactApexChart from "react-apexcharts"
import getChartColorsArray from "../../components/Common/ChartsDynamicColor";
import { Spinner } from "reactstrap";

const StackedColumnChart = ({ dataColors }) => {
  const [series, setSeries] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const stackedColumnChartColors = getChartColorsArray(dataColors);

  useEffect(() => {
    const fetchChartData = async () => {
      try {
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        const userId = authUser?.ID;
        const isAdmin = authUser?.Users_Type_ID === 3; // 3: Admin

        if (!userId) return;

        // Bulunduğumuz yılın başından itibaren verileri çekiyoruz
        const currentYear = new Date().getFullYear();
        const startDate = `${currentYear}-01-01T00:00:00Z`;

        // Admin ise tüm ilanlar, sürücü ise sadece kendisininkiler
        const filterStr = isAdmin 
          ? `$filter=Created_DateTime ge ${startDate}` 
          : `$filter=Users_ID eq ${userId} and Created_DateTime ge ${startDate}`;

        const response = await fetch(
          `https://hiflowapi.stechomeyazilim.info/Advert?${filterStr}&$select=Direction_Type,Created_DateTime`
        );
        const result = await response.json();

        if (result && result.value) {
          // 12 ay için başlangıç verisi (0 ile doldurulmuş)
          const gidisData = new Array(12).fill(0);
          const donusData = new Array(12).fill(0);
          const digerData = new Array(12).fill(0);

          result.value.forEach(item => {
            if (item.Created_DateTime) {
              const month = new Date(item.Created_DateTime).getMonth(); // 0-11 arası döner
              const type = item.Direction_Type?.toLowerCase();

              if (type === "gidiş" || type === "git") {
                gidisData[month]++;
              } else if (type === "dönüş") {
                donusData[month]++;
              } else {
                digerData[month]++;
              }
            }
          });

          setSeries([
            { name: "Gidiş Seferleri", data: gidisData },
            { name: "Dönüş Seferleri", data: donusData },
            { name: "Diğer", data: digerData }
          ]);
        }
      } catch (error) {
        console.error("Grafik verisi çekilemedi:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchChartData();
  }, []);

  const options = {
    chart: {
      stacked: true,
      toolbar: { show: false },
      zoom: { enabled: true }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "20%",
        borderRadius: 4
      }
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"],
    },
    colors: stackedColumnChartColors,
    legend: { position: "bottom" },
    fill: { opacity: 1 },
    tooltip: {
        y: {
            formatter: function (val) {
                return val + " Sefer"
            }
        }
    }
  }

  return (
    <React.Fragment>
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "359px" }}>
          <Spinner color="primary" />
        </div>
      ) : (
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height="359"
          className="apex-charts"
        />
      )}
    </React.Fragment>
  );
}

StackedColumnChart.propTypes = {
  dataColors: PropTypes.any
}

export default StackedColumnChart;